"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let WorkSummaryViewFilters = class WorkSummaryViewFilters extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
        this.$$cache_item = new core_1.ComponentValueCache(this, "item", "WorkSummaryViewFilters");
    }
    item;
    ux;
    b_8564662037462133_style;
    dataMembers = ['item', 'ux', 'b_8564662037462133_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: {
                    date_from: null,
                    date_to: null,
                },
                ux: null,
                b_8564662037462133_style: {
                    width: "500px",
                },
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_setData_8426_getActionArgs($event) {
        return {
            path: "item.date_from",
            value: $event.data[0],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_8564662037462133_setData_8428_getActionArgs($event) {
        return {
            path: "item.date_to",
            value: $event.data[1],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_8564662037462133_changed(event, scope) {
        return await this.actions.evh_8564662037462133_changed.executeFromDOM(this, event, scope);
    }
    async act_3943151158818434_emit_8430_getActionArgs($event) {
        return {
            event: "submit",
            value: this.item,
        };
    }
    async evh_3943151158818434_clickPreventStop(event, scope) {
        return await this.actions.evh_3943151158818434_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8424 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8423 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8424,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8423],
        });
        const act_8564662037462133_setData_8426 = new core_1.actions.SetDataAction({
            actionArgs: this.act_8564662037462133_setData_8426_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_changed_8425 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_setData_8426,
            event: "changed",
            displayName: "setData",
        });
        const act_8564662037462133_setData_8428 = new core_1.actions.SetDataAction({
            actionArgs: this.act_8564662037462133_setData_8428_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_changed_8427 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_setData_8428,
            event: "changed",
            displayName: "setData",
        });
        const evh_8564662037462133_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_changed_8425, evh_8564662037462133_changed_8427],
        });
        const act_3943151158818434_emit_8430 = new core_1.actions.EmitAction({
            actionArgs: this.act_3943151158818434_emit_8430_getActionArgs,
            displayName: "load",
            events: [],
        });
        const evh_3943151158818434_clickPreventStop_8429 = new core_1.actions.EventHandlerImpl({
            action: act_3943151158818434_emit_8430,
            event: "click.prevent.stop",
            displayName: "load",
        });
        const evh_3943151158818434_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3943151158818434_clickPreventStop_8429],
        });
        return {
            act_7315092382398562_reloadComponentData_8424,
            evh_7315092382398562_reload_8423,
            evh_7315092382398562_reload,
            act_8564662037462133_setData_8426,
            evh_8564662037462133_changed_8425,
            act_8564662037462133_setData_8428,
            evh_8564662037462133_changed_8427,
            evh_8564662037462133_changed,
            act_3943151158818434_emit_8430,
            evh_3943151158818434_clickPreventStop_8429,
            evh_3943151158818434_clickPreventStop,
            load: act_3943151158818434_emit_8430,
        };
    }
};
WorkSummaryViewFilters = __decorate([
    (0, vue_property_decorator_1.Component)()
], WorkSummaryViewFilters);
exports.default = WorkSummaryViewFilters;
vue_property_decorator_1.Vue.component("WorkSummaryViewFilters", WorkSummaryViewFilters);
